import React from 'react';
import { Swords, Wind, Brain, Heart } from 'lucide-react';
import type { PetStats as PetStatsType } from '../../../types/pets';

interface PetStatsProps {
  stats: PetStatsType;
}

export function PetStats({ stats }: PetStatsProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      <div className="flex items-center gap-1 text-sm">
        <Swords className="w-4 h-4 text-red-400" />
        <span className="text-red-400">STR: {stats.strength}</span>
      </div>
      <div className="flex items-center gap-1 text-sm">
        <Wind className="w-4 h-4 text-green-400" />
        <span className="text-green-400">AGI: {stats.agility}</span>
      </div>
      <div className="flex items-center gap-1 text-sm">
        <Brain className="w-4 h-4 text-blue-400" />
        <span className="text-blue-400">INT: {stats.intelligence}</span>
      </div>
      <div className="flex items-center gap-1 text-sm">
        <Heart className="w-4 h-4 text-pink-400" />
        <span className="text-pink-400">VIT: {stats.vitality}</span>
      </div>
    </div>
  );
}